export const ANNUAL_LEAVE_OVERVIEW_SCREEN = "annualLeaveOverview";
export const LEAVE_CARRYOVER_SCREEN = "leaveCarryover";
export const PROJECT_LEAVE_SCREEN = "projectLeave";
export const PROJECT_LEAVE_DETAIL_SCREEN = "projectLeaveDetail";
export const BONUS_LEAVE = "bonusLeave";
export const GENERAL_CONFIGURATION = "generalConfiguration";
export const POLICY_CONFIG_WORK_SCHEDULE_CONFIG_SCREEN = "workScheduleSetting";
export const POLICY_MANAGEMENT_EMPLOYEE_SCREEN = "policyManagementEmployee";
export const POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN = "policyManagementHistoryEmployee";
export const POLICY_MANAGEMENT_DEPARTMENT_SCREEN = "policyManagementDepartment";
export const REPORT_POLICY_MAPPING_SCREEN = "reportPolicyMapping";

// Config time action staff and manager
export const TIME_STAFF = 16;
export const TIME_PM = 17;

export const MORNING_TYPE = "MORNING";
export const AFTERNOON_TYPE = "AFTERNOON";
export const FULL_DAY_TYPE = "FULL_DAY";

export const DURATION_TYPES = [
  {
    code: FULL_DAY_TYPE,
    label: "Full day",
  },
  {
    code: MORNING_TYPE,
    label: "Morning",
  },
  {
    code: AFTERNOON_TYPE,
    label: "Afternoon",
  },
];

export const LEAVE_REQUEST_TYPE = "LEAVE_REQUEST";
export const EXPLANATION_REQUEST_TYPE = "EXPLANATION_REQUEST";
export const WORK_OUTSIDE_REQUEST_TYPE = "WORK_OUTSIDE_REQUEST";

export const SINGLE_TYPE = "single";
export const MULTIPLY_TYPE = "multiple";

export const REQUEST_TYPES = [
  {
    id: 1,
    code: LEAVE_REQUEST_TYPE,
    label: "Leave Request",
    type: [MULTIPLY_TYPE, SINGLE_TYPE],
  },
  {
    id: 2,
    code: EXPLANATION_REQUEST_TYPE,
    label: "Explanation Request",
    type: [SINGLE_TYPE],
  },
  {
    id: 3,
    code: WORK_OUTSIDE_REQUEST_TYPE,
    label: "Work outside Request",
    type: [MULTIPLY_TYPE],
  },
];

export const REQUEST_TYPE_SHIFT = "SHIFT";
export const REQUEST_TYPE_HOUR = "HOUR";

// Explanation Type
export const EXPLANATION_REFUND_BY_HOUR = "EXPLANATION_REFUND_BY_HOUR";
export const EXPLANATION_REFUND_BY_DAY = "EXPLANATION_REFUND_BY_DAY";
export const EXPLANATION_NOT_REFUND = "EXPLANATION_NOT_REFUND";

export const FOLDER_NAME_LEAVE_REQUEST = "request";
export const FOLDER_NAME_ABNORMAL = "abnormal-case";

export const OVERTIME_TABS = ["fixedTab", "flexibleTab"];
export const FIXED_TAB = "fixedTab";
export const FLEXIBLE_TAB = "flexibleTab";

// Date Format
export const DATE_FORMAT_SHORT = "YYYY-MM-DD";
export const DATE_FORMAT_FULL = "YYYY-MM-DD HH:mm:ss";
export const DATE_FORMAT_DMY = "DD-MM-YYYY";
export const DATE_FORMAT_V2 = "DD/MM/YYYY";
export const DATE_FORMAT_V2_FULL = "DD/MM/YYYY HH:mm:ss";
export const DATE_FORMAT_HM = "HH:mm";
export const DATE_FORMAT_HMS = "HH:mm:ss";
export const DATE_FORMAT_V2_DMY_HM = `${DATE_FORMAT_V2} ${DATE_FORMAT_HM}`;

export const REQUEST_TIME_OFF = "TIME_OFF";
export const REQUEST_WORK_OUTSIDE = "WORK_OUTSIDE";
export const REQUEST_EXPLANATION = "EXPLANATION";

export const REASON_WORK_OUTSIDE = "WORK_OUTSIDE";

export const OT_TYPE_FIXED = "OT_FIXED";
export const OT_TYPE_FIXED_CONFIG = "OT_FIXED_CONFIG";
export const OT_TYPE_FLEXIBLE = "OT_FLEXIBLE";
export const OT_TYPE_FIXED_IGNORE = "OT_FIXED_IGNORE";
export const OT_TYPE_FIXED_CONFIG_IGNORE = "OT_FIXED_CONFIG_IGNORE";
export const OT_TYPE_FLEXIBLE_IGNORE = "OT_FLEXIBLE_IGNORE";

export const CREATE_BY_HR = "HR";
export const CREATE_BY_EMPLOYEE = "EMPLOYEE";

export const ROLE_PROJECT_PM = "PM";

export const LATE_COMING_TYPE = "LATE_COMING";
export const EARLY_LEAVING_TYPE = "EARLY_LEAVING";
export const PARTIAL_OF_DAY_TYPE = "PARTIAL_OF_DAY";
export const LOA_CORP_13_TYPE = "LOA_CORP_13";

export const ACTUAL_EXPLANATION = [LATE_COMING_TYPE, EARLY_LEAVING_TYPE, PARTIAL_OF_DAY_TYPE, LOA_CORP_13_TYPE];

export const BLOCK = 30;

export const PAGE_DEFAULT = {
  page: 1,
  size: 10,
  total: 0,
};

export const PAGINATION_DEFAULT = {
  page: 1,
  size: 10,
};
export const TABS_TYPE = ["line", "card", "editable-card"];
export const TABS_SIZE = ["small", "default", "large"];

export const EXCEED_TYPE = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const FILE_TYPE = {
  ".xls": "XLS",
  ".xlsx": "XLSX",
  ".csv": "CSV",
  ".txt": "TXT",
  ".pdf": "PDF",
  ".png": "PNG",
  ".jpg": "JPG",
  ".jpeg": "JPEG",
  ".gif": "GIF",
  ".bmp": "BMP",
  ".tif": "TIF",
  ".tiff": "TIF",
};

export const CREATE_TYPE = "create";
export const EDIT_TYPE = "edit";
export const REMOVE_TYPE = "remove";
export const HISTORY_TYPE = "history";

export const TMS_ROLE_STAFF = "TMS_Staff_1";
export const TMS_ROLE_DU_LEAD = "TMS_DL_1";
export const TMS_ROLE_G_LEAD = "TMS_GL_1";
export const TMS_ROLE_HR = "TMS_HR_1";
export const TMS_ROLE_HRM = "TMS_HRM_1";
export const TMS_ROLE_ADMIN = "TMS_Admin_1";

export const TMS_ROLE = {
  TMS_ROLE_STAFF,
  TMS_ROLE_DU_LEAD,
  TMS_ROLE_G_LEAD,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
  TMS_ROLE_ADMIN,
};

export const ANNUAL_LEAVE_TYPE = {
  default_leave: "Phép mặc định",
  seniority_leave: "Phép thâm niên",
  prioritize_leave: "Phép ưu tiên",
  reserve_leave: "Phép bảo lưu",
  reserve_probationary_leave: "Phép bảo lưu thử việc",
  total_leave_detail: "Tổng",
};

export const RESPONSE_TYPE_SUCCESS = "success";
export const RESPONSE_TYPE_ERROR = "error";
export const RESPONSE_TYPE_WARNING = "warning";

// Annual Tab Key
export const ANNUAL_TAB_OVERVIEW = "annual-leave-overview";
export const ANNUAL_TAB_GENERAL_CONFIG = "general-configuration";
export const ANNUAL_TAB_LEAVE_CARRYOVER = "leave-carryover";
export const ANNUAL_TAB_BONUS_LEAVE = "bonus-leave";
export const ANNUAL_TAB_PROJECT_LEAVE = "project-leave";

// Policy Config Tab Key
export const POLICY_CONFIG_TAB_WORK_SCHEDULE_CONFIG = "work-schedule-config";
export const POLICY_CONFIG_TAB_RULE_SETTINGS = "rule-settings";

// Policy Management Tab Key
export const POLICY_MANAGEMENT_TAB_DEPARTMENT = "policy-management-department";
export const POLICY_MANAGEMENT_TAB_EMPLOYEE = "policy-management-employee";

export const ANNUAL_LEAVE_TABS = [
  {
    key: ANNUAL_TAB_OVERVIEW,
    tab: "Annual Leave Overview",
    component: "AnnualLeaveOverview",
    roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN, TMS_ROLE_DU_LEAD, TMS_ROLE_G_LEAD],
  },
  {
    key: ANNUAL_TAB_GENERAL_CONFIG,
    tab: "General Configuration",
    component: "GeneralConfiguration",
    roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN],
  },
  {
    key: ANNUAL_TAB_LEAVE_CARRYOVER,
    tab: "Leave Carryover",
    component: "LeaveCarryover",
    roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN, TMS_ROLE_DU_LEAD, TMS_ROLE_G_LEAD],
  },
  {
    key: ANNUAL_TAB_BONUS_LEAVE,
    tab: "Bonus Leave",
    component: "BonusLeave",
    roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN, TMS_ROLE_DU_LEAD, TMS_ROLE_G_LEAD],
  },
  // {
  //   key: ANNUAL_TAB_PROJECT_LEAVE,
  //   tab: "Project Leave",
  //   component: "ProjectLeave",
  //   roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN, TMS_ROLE_DU_LEAD, TMS_ROLE_G_LEAD],
  // },
];

export const POLICY_CONFIG_TABS = [
  {
    key: POLICY_CONFIG_TAB_WORK_SCHEDULE_CONFIG,
    tab: "Work schedule configuration",
    component: "WorkScheduleConfig",
    roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN],
  },
  // {
  //   key: POLICY_CONFIG_TAB_RULE_SETTINGS,
  //   tab: "Rule setting",
  //   component: "RuleSetting",
  //   roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN],
  // },
];

export const POLICY_MANAGEMENT_TABS = [
  {
    key: POLICY_MANAGEMENT_TAB_EMPLOYEE,
    tab: "STAFF",
    component: "PolicyManagementEmployee",
    roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN],
  },
  // {
  //   key: POLICY_MANAGEMENT_TAB_DEPARTMENT,
  //   tab: "DEPARTMENT",
  //   component: "PolicyManagementDepartment",
  //   roles: [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN],
  // },
];

export const ACTION_CREATED_TYPE = "created";
export const ACTION_EDITED_TYPE = "edited";

// ROUTER
export const ROUTER_PAGE_LOGIN = "Login";
export const ROUTER_PAGE_TIMESHEET = "Timesheets";
export const ROUTER_PAGE_REQUEST_MANAGEMENT = "Request Management";
export const ROUTER_PAGE_ONSITE_MANAGEMENT = "Onsite Management";
export const ROUTER_PAGE_OVERTIME_MANAGEMENT = "Overtime Management";
export const ROUTER_PAGE_OVERTIME_MANAGEMENT_DETAIL = "Overtime Management Detail";
export const ROUTER_PAGE_DELEGATION_MANAGEMENT = "Delegation Management";
export const ROUTER_PAGE_ABNORMAL_NOTIFICATION = "Abnormal Notification";
export const ROUTER_PAGE_CHECKIN_CHECKOUT_time = "Check In-Out Time";
export const ROUTER_PAGE_SPECIAL_EXPLANATION = "Special Explanation";
export const ROUTER_PAGE_EMPLOYEE = "Employee";
export const ROUTER_PAGE_EMPLOYEE_MANAGEMENT = "Employee Management";
export const ROUTER_PAGE_CONFIGURATION = "Configuration";
export const ROUTER_PAGE_REPORT = "Report";
export const ROUTER_PAGE_REPORT_DETAIL = "TMS Detail";
export const ROUTER_PAGE_REPORT_SUMMARY = "TMS Summary";
export const ROUTER_PAGE_REPORT_CHECK_TIME = "Check In - Check Out";
export const ROUTER_PAGE_REPORT_POLICY_MAPPING = "Report Policy Mapping";
export const ROUTER_PAGE_SETTINGS = "Settings";
export const ROUTER_PAGE_SETTING = "Setting";
export const ROUTER_PAGE_LOGS = "Logs";
export const ROUTER_PAGE_LEAVE_MANAGEMENT = "Leave Management";
export const ROUTER_PAGE_ANNUAL_LEAVE = "Annual Leave";
export const ROUTER_PAGE_PROJECT_LEAVE = "Project Leave";
export const ROUTER_PAGE_PROJECT_LEAVE_DETAIL = "Project Leave Detail";
export const ROUTER_PAGE_PAGE_NOT_FOUND = "Page Not Found";
export const ROUTER_PAGE_POLICY_SETTINGS = "Policy Settings";
export const ROUTER_PAGE_POLICY_CONFIG = "Policy Config";
export const ROUTER_PAGE_POLICY_CONFIG_CREATE = "Create Policy Config";
export const ROUTER_PAGE_POLICY_CONFIG_EDIT = "Edit Policy Config";
export const ROUTER_PAGE_POLICY_MANAGEMENT = "Policy Management";
export const ROUTER_PAGE_POLICY_MANAGEMENT_EMPLOYEE_HISTORY = "Policy Management Employee History";

// KEY TABLE WORK SCHEDULE SETTING
export const DAY_KEY = "day";
export const WORKING_DAY_KEY = "workingDay";
export const START_TIME_KEY = "startTime";
export const END_TIME_KEY = "endTime";
export const WORKING_TIME_KEY = "workingTime";
export const MINIMUM_WORKING_TIME_KEY = "minimumWorkingTime";
export const CONTINUOUS_WORKING_TIME_KEY = "continuousWorkingTime";
export const BREAK_TIME_KEY = "breakTime";

// KEY HEADER TABLE WORKING SCHEDULE SETTING
export const START_TIME_HEADER_KEY = "startTimeHeader";
export const END_TIME_HEADER_KEY = "endTimeHeader";
export const WORKING_TIME_HEADER_KEY = "workingTimeHeader";
export const CONTINUOUS_WORKING_TIME_HEADER_KEY = "continuousWorkingTimeHeader";
export const BREAK_TIME_HEADER_KEY = "breakTimeHeader";

export const MAPPING_ACTIVE_SUBMENU = {
  [ROUTER_PAGE_LEAVE_MANAGEMENT]: "/leave-management/annual-leave",
  [ROUTER_PAGE_POLICY_SETTINGS]: "/policy-settings/policy-management",
  [ROUTER_PAGE_POLICY_MANAGEMENT_EMPLOYEE_HISTORY]: "/policy-settings/policy-management",
  [ROUTER_PAGE_TIMESHEET]: "/timesheet",
  [ROUTER_PAGE_EMPLOYEE]: "/employee/employee-management",
  [ROUTER_PAGE_LEAVE_MANAGEMENT]: "/leave-management/annual-leave",
  [ROUTER_PAGE_SETTINGS]: "/settings/settings-config",
};

export const OT_TYPES = [
  {
    key: OT_TYPE_FLEXIBLE,
    value: OT_TYPE_FLEXIBLE,
    label: "OT mới",
  },
  {
    key: OT_TYPE_FLEXIBLE_IGNORE,
    value: OT_TYPE_FLEXIBLE_IGNORE,
    label: "Không OT",
  },
];

// WORK SCHEDULE TYPE CODE
export const CALCULATE_BY_BLOCK_4_6_8 = "CALCULATE_BY_BLOCK_4_6_8";

// FILTER KEY
export const FILTER_KEY_EMPLOYEE = "employees";
export const FILTER_KEY_DIVISION = "divisions";
export const FILTER_KEY_DEPARTMENT = "departments";
export const FILTER_KEY_TIME_SHEET = "timesheetId";
export const FILTER_KEY_ROLE = "roles";
export const FILTER_KEY_APPLY_DATE = "applyDate";
export const FILTER_KEY_EXPIRE_DATE = "expireDate";
export const FILTER_KEY_PROJECT = "projectIds";
export const FILTER_KEY_ONBOARD_DATE = "onboardDate";
export const FILTER_KEY_WORK_SCHEDULE_CODE = "workScheduleCodes";
export const FILTER_KEY_WORK_SCHEDULE_TYPE = "ruleTypes";
export const FILTER_KEY_OBJECT = "object";

// FILTER TYPE
export const FILTER_TYPE_MULTIPLE_SELECT = "multiple-select";
export const FILTER_TYPE_SELECT = "select";
export const FILTER_TYPE_INPUT = "input";
export const FILTER_TYPE_DATE_RANGE = "dateRange";
export const FILTER_TYPE_BUTTON = "button";
export const FILTER_TYPE_DATE = "date";
export const FILTER_TYPE_AUTO_COMPLETE = "auto-complete";
export const FILTER_TYPE_CHECKBOX = "checkbox";

// CONFIG FROM
export const CONFIG_FROM_HRMS = "hrms";
export const CONFIG_FROM_DEFAULT_HRMS = "default_hrms";
export const CONFIG_FROM_SF4C = "sf4c";

// OBJECT TYPE LEAVE MANAGEMENT
export const OBJECT_TYPE_CMC = "CMC";
export const OBJECT_TYPE_GDC = "GDC";
export const OBJECT_TYPES = [
  {
    key: OBJECT_TYPE_CMC,
    title: OBJECT_TYPE_CMC,
    value: OBJECT_TYPE_CMC,
  },
  {
    key: OBJECT_TYPE_GDC,
    title: OBJECT_TYPE_GDC,
    value: OBJECT_TYPE_GDC,
  },
];

// TYPE VARIABLE
export const NUMBER_TYPE = "number";
export const STRING_TYPE = "string";
